export const TUMBLR_CONSUMER_KEY = '71cDgpq5xSSblQ3xEPW8rXYgOYK2RXRDEAnLYzkTjv6XXGtXIO';

export const FIREBASE_URL = 'https://sheeptown-5d69b.firebaseio.com/';

export const EMAILJS_ID = 'user_1AMEaUkmskU7hIKwUIQfA';

export const RECAPTCHA_KEY = '6LcOIqsZAAAAAAyX1E-KnICtEQIAY6GvSif-djlZ'